<template>
<div class="new-user">
    <div class="container">
        <ol class="breadcrumbs">
            <router-link to="/dashboard">Dashboard</router-link> >
            <router-link to="/profile">{{user.data.name}}</router-link><span> > Profile</span>
        </ol>
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Your Profile</h1>
        </div>   

        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-body">
                        <div v-if="error" class="alert alert-danger">{{error}}</div>
                        <div v-if="success" class="alert alert-success">{{success}}</div>
                        <form action="#" @submit.prevent="submit" class="pt-4">
                            <div class="mt-4 form-group row">
                                <label for="name" class="col-md-4 col-form-label text-md-right">Full Name</label>

                                <div class="col-md-4">
                                    <input id="name" type="name" class="form-control" name="name" required autofocus v-model="user.data.name" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">Email/Username</label>

                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" name="email" required autofocus v-model="user.data.email" />
                                </div>
                            </div>

                            <!-- <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

                                <div class="col-md-4">
                                    <input id="password" type="text" class="form-control" name="password" required v-model="form.password" />
                                </div>
                            </div>-->

                            <div class="form-group row">
                                <label for="phone" class="col-md-4 col-form-label text-md-right">Phone</label>

                                <div class="col-md-3">
                                    <input id="phone" type="tel" class="form-control" name="phone" required v-model="user.data.phone" />
                                </div>
                            </div>

                            <div class="form-group row" v-if="user.data.role > 3">
                                <label for="role" class="col-md-4 col-form-label text-md-right">Permission Level</label>

                                <div class="col-md-4">
                                    <p class="mt-2"> {{user.data.role | roleName}}</p>
                                </div>
                            </div>
                            <div class="form-group row" v-if="user.data.role <= 3">
                                <label for="role" class="col-md-4 col-form-label text-md-right">Organisation</label>

                                <div class="col-md-4">
                                    <p class="mt-2"> {{user.data.organisation}}</p>
                                </div>
                            </div>

                            <div class="form-group row mb-4 mt-4">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-lg btn-primary">
                                        Update
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    db
} from "../main";
import {
    mapGetters
} from "vuex";

//const usersRef = db.ref("users");

export default {
    name: "NewUser",
    computed: {
        ...mapGetters({
            user: "user"
        }),
    },
    data() {
        return {
            form: {
                password: "",
            },
            success: null,
            error: null,
        };
    },
    methods: {
        test(){
            console.log('test')
        },
        submit() {
            var t = this;
            t.success = null;
            t.error = null;
            //secondary Auth object hack so as user isnt logged into new account

            //Update User
            console.log(t.user);

            db.ref('users/' + t.user.auth.uid)
                .set(t.user.data)
                .then(() => {
                    console.log('User updated!')

                    t.user.auth.updateEmail(t.user.data.email);
                    t.success = "User Updated";
                })

        },
    },
};
</script>
